// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"267":"c04b5534","296":"c04b5534","323":"c04b5534","444":"c04b5534","456":"c04b5534","579":"c04b5534","783":"c04b5534","871":"c04b5534"}[chunkId] + ".chunk.css";
};